// import { createSlice } from "@marta/core/features/wizard/slice";
import { createRestructuredSlice } from "@marta/core/features/wizard/slice/wizard-restructured-reducer";

import { CgWizardState } from "./wizard-types";

const initialState: CgWizardState = {};

// export const { reducer: wizardReducer } = createSlice({ initialState });
export const { reducer: wizardReducer } = createRestructuredSlice({
  initialState,
});
